import { useEffect, useState } from "react";
import { ClioService } from "../../../api";
import { LitigationFunnelMatter } from "../../../api/models/LitigationFunnelMatter";
import { Areas } from "../Common/Areas";
import { Area } from "../Common/Area";
import { Box, Button, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { LitigationReportRequest } from "../../../api/models/LitigationReportRequest";
import { MatterData } from "../../../api/models/MatterData";
import { CustomFieldOption } from "../../../api/models/CustomField";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { startSpinner, stopSpinner } from "../../../redux/actions/spinnerActions";
import { useDispatch } from "react-redux";
import StagesReport from "../Common/StagesReport";

const MySwal = withReactContent(Swal);

export default function LitigationFunnelReport() {
    const [matters, setMatters] = useState<LitigationFunnelMatter[]>([]);
    const [matterOptions, setMatterOptions] = useState<MatterData[]>([]);

    const dispatch = useDispatch();

    const loadReport = (reportFilter: LitigationReportRequest) => {
        dispatch(startSpinner());
        ClioService.postApiClioLitigationFunnelReport(reportFilter).then((matters) => {
            setMatters(matters);
            dispatch(stopSpinner());
        }).catch(err => {
            MySwal.fire({
                icon: "error",
                title: <p className="title">Error loading data</p>,
            });
            dispatch(stopSpinner());
        });
    }

    useEffect(() => {
        ClioService.getApiClioLitigationMatters().then((matters) => {
            setMatterOptions(matters.sort((a, b) => {
                const aName = `${a.display_number}`;
                const bName = `${b.display_number}`;
                return aName.localeCompare(bName)
            }));
        });
    }, [])

    return (
        <StagesReport
            matters={matters}
            matterOptions={matterOptions}
            loadReport={loadReport}
            areas={Areas}
        />);
}
